// docs on dynbamic importing. Basis for icon approach
// https://medium.com/front-end-weekly/webpack-and-dynamic-imports-doing-it-right-72549ff49234
// https://github.com/vercel/next.js/discussions/11291#discussioncomment-4303

/*
There is more to be done here - The icons are still bundling as 1 chunk, they are just lazy loaded now.
We should figure out how to not lazy-load them on page render, or minimize the size
of the chunk, or import them on a one-off depending upon the needs of the page.
*/

/* If you are using FA svg icons you need to make sure the _app.js file is importing the css for it
-- import '@fortawesome/fontawesome-svg-core/styles.css';
*/

import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useLazyLoadSportIcon } from '../../hooks/useLazyLoadIcon';
import { IBoxModelStyleProps } from '../../styles/css';
import StyledFontAwesomeIcon from './StyledFontAwesomeIcon';

export enum IconType {
  MaxPreps = 'mp',
  FontAwesome = 'fa',
  Sport = 'sport',
  Role = 'role',
  Contribution = 'contribution'
}

interface IIconProps
  extends IBoxModelStyleProps,
    Omit<FontAwesomeIconProps, 'size'> {
  className?: string;
  // High-Level Props - Used to delegate other props to correct subcomponent
  iconType?: IconType;
  icon: any;
  // Managed Props - Used to generate the appropiate SC $transientProps
  size?: number;
  height?: number;
  width?: number;
  color?: string;
  hoverColor?: string;
  spin?: boolean;
}

const Icon: React.FC<IIconProps> = ({
  iconType = IconType.FontAwesome,
  icon,
  size,
  height,
  width,
  color,
  hoverColor,
  spin,
  ...props
}) => {
  // console.log(
  //   'Icon',
  //   typeof icon,
  //   iconType,
  //   width,
  //   height,
  //   size,
  //   color,
  //   props,
  //   icon
  // );

  const sharedIconProps = {
    $color: color,
    $hoverColor: hoverColor
  };

  switch (iconType) {
    case IconType.FontAwesome: {
      if (height || width)
        console.warn(
          `'height' and 'width' not supported by 'fa' iconType. Use 'size' instead.`
        );

      // Note: We map $size to font-size, NOT the FA 'size' prop
      const faIconProps: FontAwesomeIconProps = {
        icon,
        color,
        spin,
        fixedWidth: true
      };

      return (
        <StyledFontAwesomeIcon
          {...sharedIconProps}
          {...faIconProps}
          {...props}
          $size={size}
        />
      );
    }

    case IconType.Sport:
    case IconType.Role:
    case IconType.Contribution:
    case IconType.MaxPreps: {
      const otherProps = {
        $height: height || size ? `${height || size}px` : null,
        $width: width || size ? `${width || size}px` : null
      };
      // must make it upper case :)
      const ManagedIcon = icon;

      return <ManagedIcon {...sharedIconProps} {...otherProps} {...props} />;
    }
    default:
      console.warn('Unsupported Icon iconType', iconType);
      return null;
  }
};

export default Icon;

// Using this icon will defer load (no csr) the entire sport icon chunk.
// This is an expensive operation that needs to be cleaned up so that it's
// lazy loading icon on display instead of the whole chunk on page load
export const SportIcon = ({ iconId, ...rest }) => {
  const icon = useLazyLoadSportIcon(iconId);

  return <Icon iconType={IconType.Sport} icon={icon} {...rest} />;
};
